import { resource } from "./resource";

const api = resource("/attendance-policy");

export const createAttendancePolicy = async (input = {}) => await api.post("", input);

export const getAllAttendancePolicies = async () => await api.get();

export const getAttendancePolicyById = async (id) => await api.get(`/${id}`);

export const updateAttendancePolicy = async (id, input = {}) => await api.put(`/${id}`, input);

export const getSelfAttendancePolicy = async () => await api.get("/self");

/** Which policy applies to an employee, and every policy's verdict on them. */
export const resolveAttendancePolicyFor = async (employeeId) => await api.get(`/resolve/${employeeId}`);
